import Loadable from 'components/Loadable';
import CustomerLayout from 'layout/Customer';
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';

const UserLogin = Loadable(lazy(() => import('pages/user-auth/login')));
const Verify = Loadable(lazy(() => import('pages/user-auth/verify')));
const BookConfirmed = Loadable(lazy(() => import('pages/my-reservation/book-confirmed')));
const MyReservation = Loadable(lazy(() => import('pages/my-reservation/my-reservation')));
const SelectWaiter = Loadable(lazy(() => import('pages/my-reservation/select-waiter')));
const RateWaiter = Loadable(lazy(() => import('pages/my-reservation/rate-waiter')));
const RateWaiterConfirmed = Loadable(lazy(() => import('pages/my-reservation/rate-waiter-confirmed')));

// ==============================|| CUSTOMER ROUTING ||============================== //

const CustomerRoutes = {
  path: '/customer',
  children: [
    // Public routes
    {
      path: '/customer/',
      // element: <AuthLayout />,
      children: [
        { path: 'login', element: <UserLogin />, errorElement: <ErrorBoundary /> },
        { path: 'verify', element: <Verify />, errorElement: <ErrorBoundary /> },
        // create reservation without authentication
        { path: 'add-reservation', element: <SelectWaiter />, errorElement: <ErrorBoundary /> },
        {
          path: 'add-reservation/book-confirmed',
          element: <BookConfirmed />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'review/:id',
          element: <RateWaiter />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'review/:id/rate-confirmed',
          element: <RateWaiterConfirmed />,
          errorElement: <ErrorBoundary />
        }
      ]
    },
    // Protected routes (need AuthGuard and DashboardLayout)
    {
      path: '/customer/',
      element: <CustomerLayout />,
      children: [
        {
          index: true,
          element: <Navigate to="my-reservation/active" replace />
        },
        {
          path: 'my-reservation',
          element: <Navigate to="active" replace />
        },
        {
          path: 'my-reservation/:tab',
          element: <MyReservation />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'my-reservation/:id/change',
          element: <SelectWaiter showBack={true} />,
          errorElement: <ErrorBoundary />
        },
        {
          path: 'my-reservation/:id/book-confirmed',
          element: <BookConfirmed />,
          errorElement: <ErrorBoundary />
        }
      ]
    }
  ]
};

export default CustomerRoutes;
